import React from "react";
import { CheckCheck, Check, AlertCircle, Headset, User } from "lucide-react";
import classNames from "classnames/bind";
import styles from "../../CaseChatCard.module.scss";

const cx = classNames.bind(styles);

const ChatMessageGroup = ({ group, isReceiver, time, avatar, isLast }) => {
    // isReceiver = true means Customer sent it. Admin is the sender when isReceiver is false.
    const lastMsg = group[group.length - 1];
    
    return (
        <div className={`d-flex ${!isReceiver ? "justify-content-end" : "justify-content-start"}`}>
            <div className={`d-flex max-w-75 align-items-end gap-2 ${!isReceiver ? "flex-row-reverse" : "flex-row"}`} style={{ maxWidth: "75%" }}>
                <div 
                    className={`d-flex align-items-center justify-content-center flex-shrink-0 rounded-circle text-white shadow-sm`}
                    style={{ 
                        width: "28px", height: "28px", 
                        background: !isReceiver ? "linear-gradient(to top right, #3b71ca, #3b71ca)" : "linear-gradient(to top right, #64748b, #94a3b8)" 
                    }}
                >
                    {!isReceiver ? <Headset size={14} /> : (avatar ? <img src={avatar} className="w-100 h-100 rounded-circle" style={{objectFit:"cover"}} alt="avatar"/> : <User size={14} />)}
                </div>
                
                <div className={`d-flex flex-column ${!isReceiver ? "align-items-end" : "align-items-start"}`}>
                    {group.map((msg, i) => {
                        const isFailStatus = msg.Status === "failed";
                        return (
                            <div 
                                key={i} 
                                className={cx("msg-bubble", !isReceiver ? "msg-admin" : "msg-customer", i !== group.length - 1 ? "mb-1" : "")}
                                style={{
                                    borderBottomRightRadius: !isReceiver && i === group.length - 1 ? "2px" : "16px",
                                    borderBottomLeftRadius: isReceiver && i === group.length - 1 ? "2px" : "16px",
                                }}
                            >
                                {msg.ImageUrl && (
                                    <div className="mb-2">
                                        <img src={msg.ImageUrl} alt="attachment" style={{ maxWidth: "100%", borderRadius: "8px", cursor: "pointer" }} onClick={() => window.open(msg.ImageUrl, "_blank")} />
                                    </div>
                                )}
                                <span className={isFailStatus ? "text-danger" : ""}>{msg.ChatContent}</span>
                            </div>
                        );
                    })}
                    
                    <div className={cx("msg-time", !isReceiver ? "justify-content-end" : "justify-content-start")}>
                        <span>{time}</span>
                        {!isReceiver && (
                            <>
                                {lastMsg.Status === "failed" ? (
                                    <AlertCircle className="text-danger ms-1" size={12} />
                                ) : lastMsg.IsRead ? (
                                    <CheckCheck className="text-primary ms-1" size={14} />
                                ) : (
                                    <Check className="text-secondary ms-1" size={14} />
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChatMessageGroup;
